import React from "react";
import { connect } from "react-redux";
import { Popup, Button, ValidationGroup, CheckBox } from "devextreme-react";
import TextField from "../../../../Shared/fields/TextField";
import SelectField from "../../../../Shared/fields/SelectField";
import TagField from "../../../../Shared/fields/TagField";
import SwitchField from "../../../../Shared/fields/SwitchField";
import NumberField from "../../../../Shared/fields/NumberField";
import RangeHoursWeek from "../../../../Shared/rangeHours";
import { setCentro, openCloseModalEditarCentro, doAddCentro, doUpdateCentro, openCloseModalDesactivarCentro, resetStatusModal } from "./action";
import { showToastError } from "../../../../Main/actions";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalEditar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activoPrev: null,
      originalPools: [],
      originalAditionalExams: [],
      originalPsychologicalExams: [],
      originalDays: [],
      modalStep: 1,
      estadoCentro: false,
      onHandleChange: false,
      horaSemana: null,
      horaSabado: null,
      horaDomingo: null,
      disabled: false,
    };
  }

  componentWillUnmount = () => {
    this.props.dispatch(resetStatusModal());
    this.setState({
      activoPrev: null,
      originalPools: [],
      originalAditionalExams: [],
      originalPsychologicalExams: [],
      estadoCentro: false,
    });
  }

  componentDidUpdate = (preProps) => {
    if (!preProps.isOpenModalEditar && this.props.isOpenModalEditar && !this.props.isNewCentro) {
      const { centro } = this.props;
      this.setState({
        activoPrev: centro.Status === 1,
        originalPools: [...centro.Pools],
        originalAditionalExams: [...centro.AdditionalExams],
        originalPsychologicalExams: [...centro.PsychologicalExams],
        originalDays: [...centro.Days],
        estadoCentro: centro.Status === 1,
      });
    }
  }

  getUnique = (arr, comp) => {
    const unique = arr.map((e) => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arr[e]).map((e) => arr[e]);
    return unique;
  }

  handleChange = (e) => {
    // this.setState({onHandleChange: true})
    const newCentro = { ...this.props.centro };
    if (e.element.id.includes("horario_")) {
      newCentro[e.element.id] = e.value;
      if (newCentro.Days) {
        const split_str = e.element.id.split("_");
        const _horario = split_str[1];
        newCentro.Days = newCentro.Days.map((ee) => {
          if (_horario === "domingo" && [0].includes(ee.DayId)) {
            ee.Since = e.value && e.value.value.from;
            ee.Until = e.value && e.value.value.to;
          } else if (_horario === "sabado" && [6].includes(ee.DayId)) {
            ee.Since = e.value && e.value.value.from;
            ee.Until = e.value && e.value.value.to;
          } else if (_horario === "semana" && [1, 2, 3, 4, 5].includes(ee.DayId)) {
            ee.Since = e.value && e.value.value.from;
            ee.Until = e.value && e.value.value.to;
          }
          return ee;
        });
      }
    } else if (e.element.id.includes("checkBox_day")) {
      const split_str = e.element.id.split("_");
      const _day = Number(split_str[2]);
      let dias = (newCentro.Days && newCentro.Days.filter((ee) => ee.DayId !== _day)) || [];
      let dia = (newCentro.Days && newCentro.Days.find((ee) => ee.DayId === _day)) || {};
      if (e.value === true) {
        dia.DayId = _day;
        dias.push(dia);
      }

      dias = dias.map((ee) => {
        if (newCentro.horaDomingo && [0].includes(ee.DayId)) {
          ee.Since = newCentro.horaDomingo && newCentro.horaDomingo.value.from;
          ee.Until = newCentro.horaDomingo && newCentro.horaDomingo.value.to;
        } else if (newCentro.horaSabado && [6].includes(ee.DayId)) {
          ee.Since = newCentro.horaSabado && newCentro.horaSabado.value.from;
          ee.Until = newCentro.horaSabado && newCentro.horaSabado.value.to;
        } else if (newCentro.horaSemana && [1, 2, 3, 4, 5].includes(ee.DayId)) {
          ee.Since = newCentro.horaSemana && newCentro.horaSemana.value.from;
          ee.Until = newCentro.horaSemana && newCentro.horaSemana.value.to;
        }
        return ee;
      });

      if (!this.props.isNewCentro) {
        const _arr = this.state.originalDays;
        const addedItems = dias.filter((item) => _arr.findIndex((x) => x.DayId === item.DayId) === -1);
        newCentro.newDays = addedItems;

        const deletedItems = [];
        this.state.originalDays.forEach((item) => {
          const deletedItem = dias.map((ee) => ee.DayId).find((f) => f === item.DayId);
          if (deletedItem === undefined || deletedItem === null) deletedItems.push(item.DayId);
        });
        newCentro.RelationIdDaysDelete = deletedItems;
      }

      newCentro.Days = dias;
    } else {
      switch (e.element.id) {
        case "PsychologicalExamsIds": {
          if (!this.props.isNewCentro) {
            const addedItems = e.component._selectedItems.map((ee) => ee.Id).filter((item) => this.state.originalPsychologicalExams.findIndex((x) => x.ExamId === item) === -1);
            newCentro.newPsychologicalExams = addedItems;

            const deletedItems = [];
            this.state.originalPsychologicalExams.forEach((item) => {
              const deletedItem = e.component._selectedItems.map((ee) => ee.Id).find((f) => f === item.ExamId);
              if (!deletedItem) deletedItems.push(item.RelationId);
            });
            newCentro.RelationIdPsychologicalExamsDelete = deletedItems;
          }
          newCentro[e.element.id] = e.component._selectedItems.map((ee) => ee.Id);
          break;
        }
        case "AdditionalExamsIds": {
          if (!this.props.isNewCentro) {
            const addedItems = e.component._selectedItems.map((ee) => ee.Id).filter((item) => this.state.originalAditionalExams.findIndex((x) => x.ExamId === item) === -1);
            newCentro.newAdditionalExamsExams = addedItems;

            const deletedItems = [];
            this.state.originalAditionalExams.forEach((item) => {
              const deletedItem = e.component._selectedItems.map((ee) => ee.Id).find((f) => f === item.ExamId);
              if (!deletedItem) deletedItems.push(item.RelationId);
            });
            newCentro.RelationIdAdditionalExamsDelete = deletedItems;
          }
          newCentro[e.element.id] = e.component._selectedItems.map((ee) => ee.Id);
          break;
        }
        case "PoolsIds": {
          if (!this.props.isNewCentro) {
            const addedItems = e.component._selectedItems.map((ee) => ee.Id).filter((item) => this.state.originalPools.findIndex((x) => x.ExamId === item) === -1);
            newCentro.newPoolsExams = addedItems;

            const deletedItems = [];
            this.state.originalPools.forEach((item) => {
              const deletedItem = e.component._selectedItems.map((ee) => ee.Id).find((f) => f === item.ExamId);
              if (!deletedItem) deletedItems.push(item.RelationId);
            });
            newCentro.RelationIdPoolsDelete = deletedItems;
          }
          newCentro[e.element.id] = e.component._selectedItems.map((ee) => ee.Id);
          break;
        }
        case "CielOverbook": {
          newCentro.CielOverbook = e.value;
          if (newCentro.CielOverbook === false) {
            newCentro.CielOverbookedMaximumAmount = null;
          }
          break;
        }
        case "CielOverbookedMaximumAmount": {
          newCentro.CielOverbookedMaximumAmount = e.value;
          break;
        }
        case "WorryingOverbook": {
          newCentro.WorryingOverbook = e.value;
          if (newCentro.WorryingOverbook === false) {
            newCentro.WorryingOverbookedMaximumAmount = null;
          }
          break;
        }
        case "WorryingOverbookedMaximumAmount": {
          newCentro.WorryingOverbookedMaximumAmount = e.value;
          break;
        }
        case "OccupationalOverbook": {
          newCentro.OccupationalOverbook = e.value;
          if (newCentro.OccupationalOverbook === false) {
            newCentro.OccupationalOverbookedMaximumAmount = null;
          }
          break;
        }
        case "OccupationalOverbookedMaximumAmount": {
          newCentro.OccupationalOverbookedMaximumAmount = e.value;
          break;
        }
        default: {
          newCentro[e.element.id] = e.value;
          break;
        }
      }
    }

    this.props.dispatch(setCentro(newCentro));
    //this.setState({onHandleChange: false})
  }


  handleCancel = () => {
    this.props.dispatch(openCloseModalEditarCentro(false, {}, false));
  }

  handleSave = (params) => {
    this.setState({ disabled: true });
    if (this.state.onHandleChange === true){
      this.setState({ disabled: false });
      return false;
    } 
    if (this.state.estadoCentro) {
      const result = params.validationGroup.validate();
      if (result.isValid) {
        if (this.props.isNewCentro) {
          this.props.dispatch(doAddCentro(this.props.centro));
        } else if (this.state.activoPrev && !this.state.estadoCentro) {
          this.props.dispatch(openCloseModalDesactivarCentro(true, this.props.centro));
        } else {
          this.setState({ disabled: false });
          this.props.dispatch(doUpdateCentro(this.props.centro, this.state.estadoCentro));
        }
      }else{
        this.setState({ disabled: false });
      }
    } else if (this.props.isNewCentro) {
      this.props.dispatch(doAddCentro(this.props.centro));
    } else if (this.state.activoPrev && !this.state.estadoCentro) {
      this.props.dispatch(openCloseModalDesactivarCentro(true, this.props.centro));
    } else {
      this.props.dispatch(doUpdateCentro(this.props.centro, this.state.estadoCentro));
    }
  }

  toStepTwo = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) { this.setState({ modalStep: 2 }); }
  }

  toStepThree = (params) => {
    this.setState({ disabled: false });
    const { Days } = this.props.centro;
    const _Days = Days && Days.filter((e) => e && e.DayId !== undefined && e.DayId !== null);
    const _validacionHorario = Days && Days.filter((e) => e && (e.DayId === undefined || e.DayId === null && e.Since === undefined || e.Since === null || e.Until === undefined || e.Until === null));
    if ((_Days && _Days.length > 0 && _validacionHorario && _validacionHorario.length === 0)) {
      const result = params.validationGroup.validate();
      if (result.isValid) { this.setState({ modalStep: 3 }); }
    } else if (_Days && _Days.length > 0  && _validacionHorario && _validacionHorario.length > 0) {
      this.props.dispatch(showToastError("Debe seleccionar los rangos de horarios para los dias seleccionados"));
    } else {
      this.props.dispatch(showToastError("Debe seleccionar al menos 1 día."));
    }
  }

  changeStatusActivate = (e) => {
    this.setState({ estadoCentro: !this.state.estadoCentro }, () => {
      this.handleChange(e);
    });
  }

  modalStepOne = () => {
    const centro = this.props.centro;
    return (<div>
      {this.props.isLoading && <LoadingOverlay />}
      <ValidationGroup >
        <TextField
          id="Description"
          label="Nombre del centro"
          maxLength={60}
          value={centro.Description}
          onChange={this.handleChange}
        />

        <SwitchField
          id="Active"
          label="Activado"
          defaultvalue={false}
          visible
          value={this.state.estadoCentro}
          onChange={this.changeStatusActivate}
          switchedOffText="No"
          switchedOnText="Si"
        />

        <SelectField
          id="TerritoryId"
          label="Territorio"
          value={centro.TerritoryId}
          onChange={this.handleChange}
          items={this.props.listaTerritorios}
          displayExpr="Description"
          valueExpr="Id"
        />

        <TextField
          id="Code"
          label="Código SAP"
          maxLength={60}
          value={centro.Code}
          onChange={this.handleChange}
          skipValidation={!this.state.estadoCentro}
        />

        <div className="button-row">
          <div>
            <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
          </div>
          <div>
            <Button text="Siguiente" type="success" onClick={this.toStepTwo} useSubmitBehavior />
          </div>
        </div>

      </ValidationGroup>
            </div>);
  }

  modalStepTwo = () => {
    const _activeDay = (day) => {
      if (this.props.centro.Days) {
        const _day = this.props.centro.Days.find((e) => e.DayId === day);
        if (_day) {
          return true;
        }
        return false;
      }
      return false;
    };

    const _activeHours = (daysArr) => {
      if (!this.props.centro.Days) return null;
      let _return = {};
      const _arr = this.props.centro.Days.filter((e) => daysArr.includes(e.DayId));
      if (_arr && _arr.length && _arr[0].Since && _arr[0].Until) {
        const _from = _arr[0].Since.length === 8 ? _arr[0].Since.slice(0, -3) : _arr[0].Since;
        const _to = _arr[0].Until.length === 8 ? _arr[0].Until.slice(0, -3) : _arr[0].Until;
        _return.text = `${_from} - ${_to}`;
        _return.value = {
          from: _from,
          to: _to,
        };
      } else {
        _return = null;
      }
      return _return;
    };

    return (<React.Fragment>
      <ValidationGroup>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_1"
              defaultValue={_activeDay(1)}
              width="100%"
              text="Lunes"
              style={{ paddingBottom: 10 }}
            />
          </div>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_2"
              defaultValue={_activeDay(2)}
              width="100%"
              text="Martes"
              style={{ paddingBottom: 10 }}
            />
          </div>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_3"
              defaultValue={_activeDay(3)}
              width="100%"
              text="Miércoles"
              style={{ paddingBottom: 10 }}
            />
          </div>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_4"
              defaultValue={_activeDay(4)}
              width="100%"
              text="Jueves"
              style={{ paddingBottom: 10 }}
            />
          </div>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_5"
              defaultValue={_activeDay(5)}
              width="100%"
              text="Viernes"
              style={{ paddingBottom: 10 }}
            />
          </div>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_6"
              defaultValue={_activeDay(6)}
              width="100%"
              text="Sábado"
              style={{ paddingBottom: 10 }}
            />
          </div>
          <div className="col-3">
            <CheckBox
              onValueChanged={this.handleChange}
              id="checkBox_day_0"
              defaultValue={_activeDay(0)}
              width="100%"
              text="Domingo"
              style={{ paddingBottom: 10 }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <h3><p>Horario semana laboral</p></h3>
            <RangeHoursWeek
              key="horario_semana"
              column="horario_semana"
              callBackHours={(data) => this.handleChange({ element: { id: "horario_semana" }, value: data })}
              useData={_activeHours([1, 2, 3, 4, 5])}
              disabled={!_activeDay(1) && !_activeDay(2) && !_activeDay(3) && !_activeDay(4) && !_activeDay(5)}
            />
          </div>
          <div className="col-4">
            <h3><p>Horario Sábado</p></h3>
            <RangeHoursWeek
              key="horario_sabado"
              column="horario_sabado"
              callBackHours={(data) => this.handleChange({ element: { id: "horario_sabado" }, value: data })}
              useData={_activeHours([6])}
              disabled={!_activeDay(6)}
            />
          </div>
          <div className="col-4">
            <h3><p>Horario Domingo</p></h3>
            <RangeHoursWeek
              key="horario_domingo"
              column="horario_domingo"
              callBackHours={(data) => this.handleChange({ element: { id: "horario_domingo" }, value: data })}
              disabled={!_activeDay(0)}
              useData={_activeHours([0])}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <SwitchField
              id="WorryingOverbook"
              label="Sobrecupo Preocupacionales"
              value={!!this.props.centro.WorryingOverbook}
              onChange={this.handleChange}
              switchedOffText="No"
              switchedOnText="Si"
              visible
            />
          </div>
          <div className="col-9">
            <NumberField
              inputAttr={{ maxLength: 3 }}
              max={99}
              min={0}
              label="Cantidad máxima de sobrecupo preocupacional"
              id="WorryingOverbookedMaximumAmount"
              showSpinButtons
              onChange={this.handleChange}
              value={this.props.centro.WorryingOverbookedMaximumAmount || null}
              skipValidation
              disabled={!this.props.centro.WorryingOverbook}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <SwitchField
              id="OccupationalOverbook"
              label="Sobrecupo Ocupacional"
              value={!!this.props.centro.OccupationalOverbook}
              onChange={this.handleChange}
              switchedOffText="No"
              switchedOnText="Si"
              visible
            />
          </div>
          <div className="col-9">
            <NumberField
              inputAttr={{ maxLength: 3 }}
              max={99}
              min={0}
              label="Cantidad máxima de sobrecupo Ocupacional"
              id="OccupationalOverbookedMaximumAmount"
              showSpinButtons
              onChange={this.handleChange}
              value={this.props.centro.OccupationalOverbookedMaximumAmount || null}
              skipValidation
              disabled={!this.props.centro.OccupationalOverbook}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-3">
            <SwitchField
              id="CielOverbook"
              label="Sobrecupo Ciel"
              value={!!this.props.centro.CielOverbook}
              onChange={this.handleChange}
              switchedOffText="No"
              switchedOnText="Si"
              visible
            />
          </div>
          <div className="col-9">
            <NumberField
              inputAttr={{ maxLength: 3 }}
              max={99}
              min={0}
              label="Cantidad máxima de sobrecupo Ciel"
              id="CielOverbookedMaximumAmount"
              showSpinButtons
              onChange={this.handleChange}
              value={this.props.centro.CielOverbookedMaximumAmount || null}
              skipValidation
              disabled={!this.props.centro.CielOverbook}
            />
          </div>
        </div>
        <div className="button-row">
          <div>
            <Button text="Volver" style={{ marginRight: 5 }} onClick={() => this.setState({ modalStep: 1 })} />
          </div>
          <div>
            <Button text="Siguiente" type="success" onClick={this.toStepThree} useSubmitBehavior />
          </div>
        </div>
      </ValidationGroup>
            </React.Fragment>);
  }

  modalStepThree = () => {
    const centro = this.props.centro;
    let saveText = "Guardar";

    if (this.props.isNewCentro) {
      saveText = "Agregar";
    }
    return (<React.Fragment>
      <ValidationGroup>
        <div className="row">
          <div className="col-12">
            <TagField
              label="Baterías"
              displayExpr="Description"
              valueExpr="Id"
              id="PoolsIds"
              showSelectionControls
              maxDisplayedTags={2}
              showMultiTagOnly={false}
              defaultValue={centro.PoolsIds}
              items={this.props.listaPools}
              searchEnabled
              tagTemplate={(i, e) => `<div id='tag${i.Id}' class="dx-tag-content" style="padding-right: 10px">
                  <span>${i.Description || i}</span>
                </div>`}
              validation={!!this.state.estadoCentro}
              onClosed={(e) => this.setState({ onHandleChange: false }, () => { this.handleChange(e); })}
              onOpened={(e) => { this.setState({ onHandleChange: true }); }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <TagField
              label="Prestaciones SEP"
              displayExpr="Description"
              valueExpr="Id"
              id="AdditionalExamsIds"
              hideSelectedItems={false}
              showSelectionControls
              maxDisplayedTags={2}
              showMultiTagOnly={false}
              defaultValue={centro.AdditionalExamsIds}
              items={this.props.listaAdditionalExams}
              searchEnabled
              tagTemplate={(i, e) => `<div id='tag${i.Id}' class="dx-tag-content" style="padding-right: 10px">
                  <span>${i.Description || i}</span>
                </div>`}
              validation={!!this.state.estadoCentro}
              onClosed={(e) => this.setState({ onHandleChange: false }, () => { this.handleChange(e); })}
              onOpened={(e) => { this.setState({ onHandleChange: true }); }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <TagField
              label="Prestaciones CIEL"
              displayExpr="Description"
              valueExpr="Id"
              id="PsychologicalExamsIds"
              hideSelectedItems={false}
              showSelectionControls
              maxDisplayedTags={2}
              showMultiTagOnly={false}
              defaultValue={centro.PsychologicalExamsIds}
              onClosed={this.handleChange}
              items={this.props.listaPsychologicalExams}
              searchEnabled
              tagTemplate={(i, e) => `<div id='tag${i.Id}' class="dx-tag-content" style="padding-right: 10px">
                  <span>${i.Description || i}</span>
                </div>`}
              validation={!!this.state.estadoCentro}
              onClosed={(e) => this.setState({ onHandleChange: false }, () => { this.handleChange(e); })}
              onOpened={(e) => { this.setState({ onHandleChange: true }); }}
            />
          </div>
        </div>
        <div className="button-row">
          <div>
            <Button text="Volver" style={{ marginRight: 5 }} onClick={() => this.setState({ modalStep: 2 })} />
          </div>
          <div>
            <Button text={saveText} type="success" onClick={this.handleSave} disabled={this.state.disabled} useSubmitBehavior />
          </div>
        </div>
      </ValidationGroup>
            </React.Fragment>);
  }

  render() {
    let title = "Editar Centro";

    if (this.props.isNewCentro) {
      title = "Agregar Centro";
    }
    return (
      <Popup
        title={title}
        titleTemplate="title"
        toolbarItems={[
          {
            html: `<div>Paso <span style="color: #00b2a9">${this.state.modalStep}</span> de <span style="color: #00b2a9">3</span></div>`,
            location: "after",
          },
        ]}
        dragEnabled={false}
        className="modal-mantenedores centro"
        onHiding={this.handleCancel}
        onShowing={() => { this.setState({ modalStep: 1 }); }}
        visible={this.props.isOpenModalEditar && !this.props.isOpenModalDesactivar}
        maxWidth={600}
        maxHeight={550}
        contentComponent={() => {
          switch (this.state.modalStep) {
            case 1:
              return this.modalStepOne();
            case 2:
              return this.modalStepTwo();
            case 3:
              return this.modalStepThree();
            default:
              return "";
          }
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEditar: state.mantenedorCentros.isOpenModalEditar,
  isOpenModalDesactivar: state.mantenedorCentros.isOpenModalDesactivar,
  centro: state.mantenedorCentros.centro,
  isNewCentro: state.mantenedorCentros.isNewCentro,
  isLoading: state.mantenedorCentros.isLoading,
  listaTerritorios: state.mantenedorCentros.listaTerritorios,
  listaPools: state.mantenedorCentros.listaPools,
  listaAdditionalExams: state.mantenedorCentros.listaAdditionalExams,
  listaPsychologicalExams: state.mantenedorCentros.listaPsychologicalExams,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditar);
